import LegalLayout from "@/components/LegalLayout";

export default function RefundPolicy() {
  return (
    <LegalLayout
      testid="refund-policy-page"
      title="Refund Policy"
      lastUpdated="February 2026"
    >
      <p>
        Brand-in-a-Box provides custom branding and consulting services. Due
        to the bespoke nature of our work, the following refund policy
        applies.
      </p>

      <h2>1. Refunds Before Production</h2>
      <p>
        A refund is available only if the engagement is cancelled in writing
        before any design work has commenced. In this case, any amount paid
        will be refunded in full, less applicable transaction fees.
      </p>

      <h2>2. No Refunds After Production Starts</h2>
      <p>
        Once production has begun — including discovery work, strategy
        sessions, concept exploration, or design development — payments are
        considered non-refundable.
      </p>

      <h2>3. Approved Deliverables</h2>
      <p>
        Deliverables that have been approved by the client (in writing,
        including via email or project communication) are considered final
        and accepted, and are not eligible for refund.
      </p>

      <h2>4. Custom Creative Services</h2>
      <p>
        Custom creative work is non-returnable. Unlike off-the-shelf products,
        bespoke branding cannot be resold or reused, and reflects time,
        expertise, and original creative output.
      </p>

      <h2>5. Disputes</h2>
      <p>
        Any refund or billing dispute must be submitted in writing to{" "}
        <a href="mailto:support@bigeyedeassystems.com">support@bigeyedeassystems.com</a>{" "}
        within 14 calendar days of the relevant invoice or deliverable. We
        will respond within 5 business days and work toward a fair
        resolution.
      </p>

      <h2>6. Goodwill Adjustments</h2>
      <p>
        While our policy is strict by design — to protect both clients and our
        team — we reserve the right to issue goodwill adjustments at our sole
        discretion in exceptional circumstances. Goodwill adjustments do not
        create precedent.
      </p>

      <h2>7. Chargebacks</h2>
      <p>
        Initiating a chargeback without first contacting Brand-in-a-Box
        constitutes a violation of our Terms of Service and may result in
        cancellation of the engagement and recovery of costs.
      </p>

      <h2>8. Contact</h2>
      <p>
        Refund inquiries: <a href="mailto:support@bigeyedeassystems.com">support@bigeyedeassystems.com</a>.
      </p>
    </LegalLayout>
  );
}
